import {CameraAnchor} from "./cameraAnchor.js";
import {TrackTracer} from "../../../../track/trackTracer.js";

/**
 * A camera anchor on a rails next to the track
 */
export class CameraAnchorRails extends CameraAnchor {
    /**
     * Construct a rails anchor
     * @param {Track} track The track to follow
     * @param {Vector3} offset The camera offset
     * @param {boolean} [rotate] True if the offset should be rotated
     */
    constructor(track, offset, rotate = true) {
        super();

        this.track = track;
        this.offset = offset;
        this.rotate = rotate;
        this.tracer = new TrackTracer(track);
    }

    /**
     * Calculate the anchor position given a target position
     * @param {Vector3} target The target position
     * @param {number} distance The distance traveled along the track
     * @param {number} lap The lap length
     */
    calculatePosition(target, distance, lap) {
        if (this.rotate)
            this.tracer.trace(
                this.position,
                this.offset,
                distance % lap);
        else
            this.position.copy(target).add(this.offset);
    }
}